<template>
  <div class="header">
    <div class="header_container">
      <div class="left">
        <div v-if="!mobileDevice"
             v-on:click="goto('/home')"
             class="logo"></div>
        <div v-if="mobileDevice"
             v-on:click="goto('/home')"
             class="logo"></div>
      </div>
      <div class="right">
        <navbar :menuLists="menuData"
                class="block_element"
                mode="horizontal"
                style="background: transparent;" />
        <div class="lang block_element"
             v-if="lang === 'en'"
             v-on:click="clickLang('zh')">中文</div>
        <div class="lang block_element"
             v-if="lang === 'zh'"
             v-on:click="clickLang('en')">EN</div>
        <img v-if="mobileDevice && !showMobileMenu"
             class="menuBtn"
             v-on:click="triggerMenu()"
             src="@/assets/images/menuOpen.png">
        <img v-if="mobileDevice && showMobileMenu"
             class="menuBtn"
             v-on:click="triggerMenu()"
             style="width: 0.25rem; margin: 0 0.1rem;"
             src="@/assets/images/menuClose.png">
      </div>
      <mobileNav v-if="mobileDevice"
                 :show="showMobileMenu"
                 :menuLists="menuData"
                 @changePath="triggerMenu()"
                 style="height: auto;"
                 class="block_element"></mobileNav>
    </div>
  </div>
</template>

<script>
import Navbar from '@/components/Navbar'
import MobileNav from './mobileNav'
import Scroll from '../../mixin/scroll'

export default {
  props: {},
  components: {
    Navbar,
    MobileNav
  },
  mixins: [Scroll],
  computed: {
    lang: {
      get() {
        return this.$store.state.lang
      },
      set(val) {
        this.$store.commit('set_lang', val)
      }
    },
    mobileDevice: {
      get() {
        return this.$store.state.mobileDevice
      }
    }
  },
  data() {
    return {
      showMobileMenu: false,
      menuData: []
    }
  },
  mounted() {
    this.getMenu()

    this.hearderBg()
    const resetBg = () => {
      const headerEl = document.querySelector('.header')
      const path = this.$route.path
      if (path === '/home') {
        if (this.scrollTop < 1 && headerEl.classList.contains('whiteBg')) {
          headerEl.classList.remove('whiteBg')
        } else if (!headerEl.classList.contains('whiteBg')) {
          headerEl.classList.add('whiteBg')
        }
      }

      const navBottom = document.querySelector('.el-carousel').offsetHeight - document.querySelector('.header').offsetHeight
      if (this.scrollTop > navBottom) {
        headerEl.classList.add('border')
      } else {
        headerEl.classList.remove('border')
      }
    }
    this.eventCallback.push(resetBg)
  },
  watch: {
    // 监听变化
    lang(n, l) {
      this.getMenu()
    },
    $route(to, from) {
      this.hearderBg()
    }
  },
  methods: {
    clickLang(l) {
      this.lang = l
    },
    triggerMenu() {
      this.showMobileMenu = !this.showMobileMenu
    },
    getMenu() {
      this.menuData = [
        {
          path: '/aboutus',
          label: this.$t('route.aboutus')
        },
        {
          path: '/rank',
          label: this.$t('route.rank')
        },
        {
          path: '/ev',
          label: this.$t('route.ev')
        },
        {
          path: '/salvageValue',
          label: this.$t('route.salvageValue')
        },
        {
          path: '/secondHand',
          label: this.$t('route.secondHand')
        }
      ]
    },
    hearderBg() {
      const path = this.$route.path
      const headerEl = document.querySelector('.header')
      if (path === '/home') {
        headerEl.classList.remove('whiteBg')
      } else {
        headerEl.classList.add('whiteBg')
      }
    },
    goto(path) {
      this.$router.push({ path })
    }
  }
}
</script>

<style lang="scss" scoped>
.header {
  position: fixed;
  top: 0px;
  width: 100%;
  color: rgba(255, 255, 255, 1);
  height: 0.9rem;
  background: rgba(0, 0, 0, 0.5);
  z-index: 99;
  .header_container {
    // max-width: 12rem;
    width: 1200px;
    max-width: 90%;
    margin: 0 auto;
    height: 100%;
    // padding: 0 0.24rem;
    div {
      display: inline-block;
      height: 100%;
    }
    .left {
      float: left;
      .logo {
        display: inline-block;
        width: 1.75rem;
        cursor: pointer;
        height: 0.36rem;
        background-image: url("../../assets/images/header_logo.png");
        background-size: cover;
        background-position: center;
        /* 背景图片是否重复 */
        background-repeat: no-repeat;
        background-attachment: local;
        // 居中
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
      }
      .iblock {
        display: inline-block;
        height: 100%;
        width: 0;
        vertical-align: middle;
      }
    }

    .right {
      float: right;
      // padding-right: 0.2rem;
      .lang {
        font-size: 15px;
        font-weight: 500;
        // margin: 0 0.2rem;
        margin-left: 0.2rem;
        cursor: pointer;
        line-height: 0.86rem;
      }

      .menuBtn {
        width: 0.46rem;
      }

      /deep/.el-menu {
        // display: inline-block;
        margin: 0rem;
        background: transparent;
        .el-menu-item {
          font-size: 15px;
          font-weight: 600;
          color: rgba(255, 255, 255, 1);
          line-height: 0.43rem !important;
          padding: 0 0.2rem;
          height: 0.48rem !important;
          transition: color 0s;

          &:hover {
            background: transparent;
            color: rgb(92, 149, 255);
          }

          &.is-active {
            background: transparent;
          }
        }
      }

      .mobileNav {
        display: none;
      }
    }
  }

  .block_element {
    display: inline-block;
    vertical-align: middle;
  }

  &.whiteBg {
    background: rgba(255, 255, 255, 1);
    color: rgba(0, 0, 0, 1);
    .header_container {
      .left {
        .logo {
          background-image: url("../../assets/images/header_logo2.png");
        }
      }
      .right {
        /deep/.el-menu {
          .el-menu-item {
            color: rgba(0, 0, 0, 1);
          }
        }
      }
    }
  }

  &.border {
    box-shadow: 0 1px 1px rgba(0, 0, 0, 0.1);
  }

  @media only screen and (max-width: 750px) {
    .header_container {
      color: rgba(58, 58, 58, 1);
      background: #fff;
    }

    .header_container {
      max-width: 100%;
      padding: 0 0.24rem;
      .right {
        .lang {
          font-size: 0.28rem;
          font-weight: 400;
          line-height: 0.94rem;
          margin-right: 0.2rem;
        }
      }
      .left {
        .logo {
          background-image: url("../../assets/images/header_logo2.png");
        }
      }
    }

    .el-menu {
      display: none;
    }

    .mobileNav {
      display: inline-block;
    }
  }
}
</style>
